import { useMutation } from "@apollo/client";
import {
  TrashIcon,
  EyeIcon,
  ArrowDownTrayIcon,
} from "@heroicons/react/24/outline";
import { Button, IconButton, Modal } from "../../../../../../../components/ui";
import { DELETE_CONTACT_DOCUMENT } from "../../../../../../../graphql/mutation/ContactDocument";
import { isPreviewableDocument } from "../../../../../../../util/documentPreview";
import CopyDocumentLinkButton from "../../../../../../../components/Documents/CopyDocumentLinkButton";

const Actions = props => {
  const { id, values } = props || {};
  const [deleteContactDocument] = useMutation(DELETE_CONTACT_DOCUMENT);
  const canPreviewInModal = isPreviewableDocument({
    fileType: values?.meta?.fileType,
    fileName: values?.meta?.name,
    viewUrl: values?.meta?.viewUrl,
  });

  const loading = false;
  const deleteModalProps = {
    title: "Are you sure?",
    scale: "sm",
    description: `Would you like to delete contact document '${values?.meta?.name}'?`,
    closeOnBackdrop: true,
    renderBody: ({ closeModal }) => {
      const handleDelete = () => {
        deleteContactDocument({
          variables: {
            input: {
              contactId: +values?.meta?.contactId,
              name: values?.meta?.name,
            },
          },
          update: (cache, { data }) => {
            const { deleteContactDocument: { success } = {} } = data;
            if (success) {
              closeModal();
              cache.evict({
                id: cache.identify({
                  __typename: "ContactDocument",
                  id,
                }),
              });
            }
          },
        });
      };

      return (
        <div className="mt-4 flex">
          <Button
            className="mr-3"
            label={"Cancel"}
            action={"default"}
            onClick={() => {
              closeModal?.();
            }}
          />
          <Button
            label={loading ? "Deleting" : "Delete"}
            disabled={loading}
            onClick={handleDelete}
          />
        </div>
      );
    },
  };

  const viewModalProps = {
    title: values?.meta?.name ?? "Document Preview",
    scale: "fullscreen",
    renderBody: () => {
      return (
        <div className="mt-4 h-[85vh] w-full">
          <iframe
            title={values?.meta?.name ?? "Document Preview"}
            src={values?.meta?.viewUrl}
            className="h-full w-full rounded-md border border-gray-200"
          />
        </div>
      );
    },
  };

  if (typeof id !== "number") {
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            <CopyDocumentLinkButton fileName={values?.meta?.name} />
            {canPreviewInModal ? (
              <Modal {...viewModalProps}>
                <IconButton variant="clean" title="View Document">
                  <EyeIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
                </IconButton>
              </Modal>
            ) : (
              <IconButton
                variant="clean"
                title="Preview not available for this file type"
              >
                <EyeIcon className={`h-4 w-4 cursor-not-allowed text-gray-300`} />
              </IconButton>
            )}
            <IconButton variant="clean" title="Download Contact Document">
              <ArrowDownTrayIcon
                className={`h-4 w-4 cursor-pointer text-gray-400`}
                onClick={() => window.open(values?.meta?.url, "_blank")}
              />
            </IconButton>
            <Modal {...deleteModalProps}>
              <IconButton variant="clean" title="Delete Contact Document">
                <TrashIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
              </IconButton>
            </Modal>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
